import { Flex, Modal } from "antd";
import "./index.css";
import { ReactComponent as EditV2 } from "../../../../assets/images/icon/editV2.svg";
import { ReactComponent as Trash } from "../../../../assets/images/icon/trash.svg";
import { isIOS } from "react-device-detect";

interface IProps {
  feedId: number;
  feedComment: IFeedCommentWebResponseGraphQl;
  isOpen: boolean;
  setIsOpen: Function;
  onClick?: (clickId: number) => void;
}

interface IClaimData {
  id: number;
  label: React.ReactNode;
  value: number;
}
const optionList: Array<IClaimData> = [
  {
    id: 1,
    label: (
      <Flex gap={16} style={{ alignItems: "center" }}>
        <EditV2 stroke="var(--secondarys400)" width={16} style={{ padding: '8px' }} />
        <div className="body/b3 secondary/s800">수정</div>
      </Flex>
    ),
    value: 1,
  },
  {
    id: 2,
    label: (
      <Flex gap={16} style={{ alignItems: "center" }}>
        <Trash stroke="var(--secondarys400)" width={16} style={{ padding: '8px' }} />
        <div className="body/b3 secondary/s800">삭제</div>
      </Flex>
    ),
    value: 2,
  },
];

const MyCommentBottomSheet = ({
  feedId,
  feedComment,
  isOpen,
  setIsOpen,
  onClick,
}: IProps) => {
  const contentHeight = 136 + (isIOS ? 34 : 0);
  const minWidth = window.innerWidth <= 480 ? "100vw" : "480px";
  const marginInline =
    window.innerWidth <= 480 ? "0" : (window.innerWidth - 480) / 2;

  const clickOption = (id: number) => {
    onClick?.(id);
  };
  return (
    <>
      <Modal
        transitionName="custom-modal"
        style={{
          top: `calc(100vh - ${contentHeight}px)`,
          padding: 0,
          margin: 0,
        }}
        styles={{
          content: {
            minWidth: minWidth,
            height: `${contentHeight}px`,
            overflow: "scroll",
            borderRadius: "16px 16px 0 0",
            marginInline: marginInline + "px",
            padding: `0 0 ${isIOS ? "34px" : 0} 0 `,
          },
          body: { padding: "var(--space20)", }
        }}
        open={isOpen}
        closeIcon={null}
        footer={null}
        onCancel={() => {
          setIsOpen(false);
        }}
      >
        {optionList
          .filter((q) => (feedComment.isHiddenByClaim ? q.id === 2 : true))
          .map((claim) => (
            <Flex
              key={claim.id}
              align='center'
              justify="space-between"
              style={{
                cursor: "pointer",
                paddingBlock: '8px'
              }}
              onClick={() => {
                clickOption(claim.id);
              }}
            >
              {claim.label}
            </Flex>
          ))}
      </Modal>
    </>
  );
};

export { MyCommentBottomSheet };
